import FunnelHeader from 'components/signUpFunnel/shared/FunnelHeader';
import useQuery from 'hooks/useQuery';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';
import HCWaveBorder from 'images/HCWaveBorder.svg';
import HomeChefKrogerLogo from 'images/logo/homeChefKroger.png';
import HCBalsamicSteak from 'images/signUpFunnel/intro-balsamic-butter-chive-steak-plate-napkin.png';
import HCCajunChicken from 'images/signUpFunnel/intro-cajun-style-red-pepper-crusted-chicken-plate-napkin.png';

const HomeChefHeader = ({ isFamilyLead }) => {
  const { isQueryParamTrue: hasKrogerParam } = useQuery('kroger', 'true');
  const { isMobileOrTablet } = useScreenSizeConstants();
  const { isQueryParamTrue: isAdSource } = useQuery('source', 'ad');

  return (
    <>
      {!hasKrogerParam && isAdSource && (
        <div className="relative">
          <div className="bg-green-110 py-8 text-center">
            <FunnelHeader
              isCentered
              title={isMobileOrTablet ? '#1 in\nConvenience*' : '#1 in Convenience*'}
              subtitle="Home Chef has the most convenient meal options of leading meal kits."
              titleClassName="mx-auto max-w-xl text-white-100 whitespace-pre-line bp1:max-w-3xl"
              subtitleClassName="mx-auto max-w-sm text-white-100 bp1:max-w-3xl"
            />
          </div>

          <div
            style={{ backgroundImage: `url(${HCWaveBorder})` }}
            className="-mt-px mb-8 h-4 bg-cover bg-repeat-round p-0 bp1:h-12"
          />
          <div>
            <img
              className="absolute -right-10 -top-8 w-44 bp1:inset-1/2 bp1:top-16 bp1:w-72 bp1:translate-x-72"
              src={HCBalsamicSteak}
              alt="Balsamic Butter Chive Steak"
            />
            <img
              className="absolute -left-10 -top-8 w-44 bp1:inset-1/2 bp1:top-16 bp1:w-72 bp1:-translate-x-[35rem]"
              src={HCCajunChicken}
              alt="Cajun-Style Red Pepper-Crusted Chicken"
            />
          </div>
        </div>
      )}
      {hasKrogerParam && (
        <div
          className={`mb-4 flex justify-center pt-8 ${isFamilyLead ? 'bp1:-mb-10' : 'bp1:mb-6'}`}
        >
          <img src={HomeChefKrogerLogo} alt="Home Chef Kroger" className="w-full max-w-[27rem]" />
        </div>
      )}
    </>
  );
};

HomeChefHeader.propTypes = {
  isFamilyLead: PropTypes.bool.isRequired,
};

export default HomeChefHeader;
